module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dCMlW"))).then(() => parcelRequire('37nVf'));